export const CHART_COLORS = {
  primary: '#1976d2',
  average: '#4A90E2',
  maximum: '#4ECDC4',
  minimum: '#FF6B6B',
};
